import React from 'react';
import { FaTimes, FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import './styles.css';

export default function ProjectModal({ project, onClose }) {
  if (!project) return null;

  return (
    <div className="modal__backdrop" onClick={onClose}>
      <div className="modal__content" onClick={(e) => e.stopPropagation()}>
        <button className="modal__close" onClick={onClose} aria-label="Close">
          <FaTimes />
        </button>

        {project.image && (
          <img src={project.image} alt={project.title} className="modal__img" />
        )}

        <div className="modal__body">
          <div className="modal__tags">
            {project.tags?.map((tag, i) => (
              <span className="modal__tag" key={i}>{tag}</span>
            ))}
          </div>

          <h2 className="modal__title">{project.title}</h2>
          <span className="modal__date">{project.date}</span>
          <p className="modal__desc">{project.description}</p>

          <div className="modal__actions">
            {project.github && (
              <a href={project.github} target="_blank" rel="noreferrer" className="modal__btn modal__btn--secondary">
                <FaGithub /> Source Code
              </a>
            )}
            {project.live && (
              <a href={project.live} target="_blank" rel="noreferrer" className="modal__btn modal__btn--primary">
                <FaExternalLinkAlt /> Live Demo
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
